/*
 * VirtualGrid  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { VirtuosoGrid } from "react-virtuoso";

export interface IVirtualGridProps extends React.ComponentProps<typeof VirtuosoGrid> {}

export const VirtualGrid: React.FC<IVirtualGridProps> = (props) => <VirtuosoGrid {...props} />;
